<template>
    <div :class="{ 'disabled-picker': disabled }">
        <date-range-picker
            v-model="dateRange"
            :maxDate="maxDate"
            :minDate="minDate"
            :locale-data="locale_data"
            :opens="opens"
            @update="(selectedOpt) => updateDate(selectedOpt)"
            :date-format="dateFormat"
        />
    </div>
</template>

<script>
    import DateRangePicker from 'vue2-daterange-picker'
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

    export default {
        props: {
            disabledDates: {
                type: Array,
                default: () => []
            },
            maxDate : {
                type: String
            },
            minDate: {
                type: String
            },
            disabled: {
                type: Boolean,
                default: false
            },
            opens: {
                type: String,
                default: 'right'
            }
        },
        data() {
            return {
                dateRange: {},
                locale_data: {
                    direction: 'ltr',
                    format: 'dd/mm/yyyy',
                    separator: ' - ',
                    applyLabel: 'Seleccionar',
                    cancelLabel: 'Cancelar',
                    weekLabel: 'W',
                    customRangeLabel: 'Custom Range',
                    daysOfWeek: ['Dom','Lun', 'Mar', 'Miérc', 'Juev', 'Vier', 'Sáb'],
                    monthNames: ['En', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Ag', 'Sept', 'Oct', 'Nov', 'Dec'],
                    firstDay: 1
                }
            }
        },
        methods: {
            updateDate() {
                this.dateRange.startDate = moment(new Date(this.dateRange.startDate)).format('MM-DD-YYYY')
                this.dateRange.endDate = moment(new Date(this.dateRange.endDate)).format('MM-DD-YYYY')
                this.$emit('selected', this.dateRange)
            },
            dateFormat(classes, date) {
                if (!classes.disabled) {
                    let mes = date.getMonth() + 1;
                    let dia = date.getDate();
                    let dat = mes.toString().padStart(2, '0') + '-' + dia.toString().padStart(2, '0') + '-' + date.getFullYear();

                    classes.disabled = this.disabledDates.includes(dat);
                }
                return classes
            }
        },
        components: { 
            DateRangePicker
        }
    }
</script>

<style scoped>
    .vue-daterange-picker {
        width: 100%;
    }
    .disabled-picker {
        pointer-events: none;
        opacity: 0.5;
    }
</style>